<template>
    <section>
        <loading id="spinner" :active="loading" :can-cancel="false" :is-full-page="true"></loading>

		<ul id="tabs-configuracao" class="tabs">
			<li v-for='(configuracao, index) in configuracoes' class="tab col s3"><a :class="index == 0? 'active' : ''" :href="'#' + configuracao.modalidade">{{configuracao.modalidade}}</a></li>            
        </ul>     
		<br>	
		<fieldset>
			<div v-for='configuracao in configuracoes' :id="configuracao.modalidade">
				
				<div class="row">
					<div class="col s12">
						<p>
							<span style="font-size: large; font-weight: bold;">Item 1:</span>&nbsp;
							<span style="font-size: medium;">"Sua ação possui parcerias externas?"</span>
						</p>

					</div>

					<p class="center" v-if="configuracao.sua_acao_possui_parcerias_externas.length === 0">
						<span class="grey-text" style="font-style: italic">Não há opções parâmetrizadas para esse item.</span>
					</p>

					<div v-else>
						<div v-for="(item1_opt, item1_opt_i) in configuracao.sua_acao_possui_parcerias_externas"
							 :key="item1_opt_i">
							<div class="input-field col m6 s12" >
								<input type="text" v-model="item1_opt.opcao" name="opcao" :id="`item1_opt_opcao_${item1_opt_i}`" :readonly='bloqueio == true'>
								<label :for="`item1_opt_opcao_${item1_opt_i}`">Opção</label>
							</div>

							<div class="input-field col m6 s12" >
								<input type="number" min="0" v-model="item1_opt.pontos" name="pontos" :id="`item1_opt_pontos_${item1_opt_i}`" :readonly='bloqueio == true'>
								<label :for="`item1_opt_pontos_${item1_opt_i}`">Pontos</label>
							</div>
						</div>
					</div>

				</div>

				<div class="row">
					<div class="col s12">
						<p>
							<span style="font-size: large; font-weight: bold;">Item 2:</span>&nbsp;
							<span style="font-size: medium;">"Relatórios de bolsistas da ação do edital anterior:"</span>
						</p>

					</div>

					<div class="input-field col m6 s12">
						<select name="relatorio_de_bolsista_nao_atende" id="sel_relatorio_bolsista_nao_atende"
								class="materialize-select"
								v-model="configuracao.relatorio_de_bolsistas_nao_atende"
								:disabled='bloqueio == true'>
							<option value="" disabled>Selecione uma opção</option>
							<option value="elimina_imediatamente">Elimina Imediatamente</option>
							<option value="cai_exigencia">Cai em Exigência</option>
						</select>
						<label for="sel_relatorio_bolsista_nao_atende">Relatório de bolsista (NÃO ATENDE)</label>
					</div>

					<div class="input-field col m6 s12">
						<select name="participacao_na_siac_nao_atende" id="sel_participacao_na_siac_nao_atende"
								v-model="configuracao.participacao_na_siac_nao_atende"
								:disabled='bloqueio == true'>
							<option value="" disabled>Selecione uma opção</option>
							<option value="elimina_imediatamente">Elimina Imediatamente</option>
							<option value="cai_exigencia">Cai em Exigência</option>
						</select>
						<label for="sel_participacao_na_siac_nao_atende">Apresentação de trabalho na SIAC (NÃO ATENDE)</label>
					</div>

				</div>

				<div class="row">
					<div class="col s12">
						<p>
							<span style="font-size: large; font-weight: bold;">Item 3:</span>&nbsp;
							<span style="font-size: medium;">"Participação na SIAC:"</span>
						</p>

					</div>

					<p class="center" v-if="configuracao.participacao_na_siac.length === 0">
						<span class="grey-text" style="font-style: italic">Não há opções parâmetrizadas para esse item.</span>
					</p>

					<div v-else>
						<div v-for="(item3_opt, item3_opt_i) in configuracao.participacao_na_siac"
							 :key="item3_opt_i">
							<div class="input-field col m6 s12" >
								<input type="text" v-model="item3_opt.opcao" name="opcao" :id="`item3_opt_opcao_${item3_opt_i}`" :readonly='bloqueio == true'>
								<label :for="`item3_opt_opcao_${item3_opt_i}`">Opção</label>
							</div>

							<div class="input-field col m6 s12" >
								<input type="number" min="0" v-model="item3_opt.pontos" name="pontos" :id="`item3_opt_pontos_${item3_opt_i}`" :readonly='bloqueio == true'>
								<label :for="`item3_opt_pontos_${item3_opt_i}`">Pontos</label>
							</div>
						</div>

						<div class="input-field col s12" >
							<input type="number" min="0" v-model="configuracao.participacao_na_siac_maximo_pontos"
								   name="participacao_na_siac_maximo_pontos"
								   id="participacao_na_siac_maximo_pontos"
								   :readonly='bloqueio == true'>
							<label for="participacao_na_siac_maximo_pontos">Máximo de Pontos</label>
						</div>
					</div>
					
				</div>
				<div class="row">
					<div class="col s12">
						<p>
							<span style="font-size: large; font-weight: bold;">Item 4:</span>&nbsp;
							<span style="font-size: medium;">"Estudantes vinculados à ação:"</span>
						</p>
					</div>

					<p class="center" v-if="configuracao.quantidade_estudantes_orientados.length === 0">
						<span class="grey-text" style="font-style: italic">Não há opções parâmetrizadas para esse item.</span>
					</p>

					<div v-else>
						<div v-for="(item4_opt, item4_opt_i) in configuracao.quantidade_estudantes_orientados"
							 :key="item4_opt_i">
							<div class="input-field col m6 s12" >
								<input type="text" v-model="item4_opt.opcao" name="opcao" :id="`item4_opt_opcao_${item4_opt_i}`" :readonly='bloqueio == true'>
								<label :for="`item4_opt_opcao_${item4_opt_i}`">Opção</label>
							</div>

							<div class="input-field col m6 s12" >
								<input type="number" min="0" v-model="item4_opt.pontos" name="pontos" :id="`item4_opt_pontos_${item4_opt_i}`" :readonly='bloqueio == true'>
								<label :for="`item4_opt_pontos_${item4_opt_i}`">Pontos</label>
							</div>
						</div>
					</div>

				</div>

				<div class="row" v-if="configuracao.modalidade == 'Evento'">
					<div class="col s12">
						<p>
							<span style="font-size: large; font-weight: bold;">Item 5:</span>&nbsp;
							<span style="font-size: medium;">"Carga Horária do Evento:"</span>
						</p>

					</div>

					<p class="center" v-if="configuracao.carga_horaria_evento.length === 0">
						<span class="grey-text" style="font-style: italic">Não há opções parâmetrizadas para esse item.</span>
					</p>

					<div v-else>
						<div v-for="(item5_opt, item5_opt_i) in configuracao.carga_horaria_evento"
							 :key="item5_opt_i">
							<div class="input-field col m6 s12" >
								<input type="text" v-model="item5_opt.opcao" name="opcao" :id="`item5_opt_opcao_${item5_opt_i}`" :readonly='bloqueio == true'>
								<label :for="`item5_opt_opcao_${item5_opt_i}`">Opção</label>
							</div>

							<div class="input-field col m6 s12" >
								<input type="number" min="0" v-model="item5_opt.pontos" name="pontos" :id="`item5_opt_pontos_${item5_opt_i}`" :readonly='bloqueio == true'>
								<label :for="`item5_opt_pontos_${item5_opt_i}`">Pontos</label>
							</div>
						</div>
					</div>

				</div>

				<!--div class="row">
					<div class="col s12">
						<p>
							<span style="font-size: large; font-weight: bold;">Item 5:</span>&nbsp;
							<span style="font-size: medium;">"Tempo de Existência da Ação:"</span>
						</p>

					</div>

					<p class="center" v-if="configuracao.tempo_existencia_acao.length === 0">
						<span class="grey-text" style="font-style: italic">Não há opções parâmetrizadas para esse item.</span>
					</p>

					<div v-else>
						<div v-for="(item5_opt, item5_opt_i) in configuracao.tempo_existencia_acao"
							 :key="item5_opt_i">
							<div class="input-field col m6 s12" >
								<input type="text" v-model="item5_opt.opcao" name="opcao" :id="`item5_opt_opcao_${item5_opt_i}`" :readonly='bloqueio == true'>
								<label :for="`item5_opt_opcao_${item5_opt_i}`">Opção</label>
							</div>

							<div class="input-field col m6 s12" >
								<input type="number" min="0" v-model="item5_opt.pontos" name="pontos" :id="`item5_opt_pontos_${item5_opt_i}`" :readonly='bloqueio == true'>
								<label :for="`item5_opt_pontos_${item5_opt_i}`">Pontos</label>
							</div>
						</div>
					</div>

				</div-->
			</div>
			<br>
			<div class="row">
				<div class="col s12">
					<button v-if='!bloqueio' class="btn-small waves-effect waves-light indigo left"
							:disabled="loading"
							@click="salva">Salvar <i class="material-icons left">save</i></button>
				</div>
			</div>
		</fieldset>
    </section>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "configuracao_analise_tecnica",
    components: {
        Loading,
    },
    props: {
        configuracaoPadrao: {
            type: String,
            default: null,
        },
		bloqueio: {
			type: String,
            default: null,
		}
    },
    data() {
        return {
            configuracoes: JSON.parse(this.configuracaoPadrao),
            loading: false,
        }
    },
    methods: {
        async salva() {
            this.loading = true

            await this.$http.post('/api/configuracoes-at', this.configuracoes).then(response => {
                Swal.fire('Sucesso!', response.body.msg, 'success')
            }, error => {
                Swal.fire({ title: 'Ocorreu um erro!', text: error.body.msg, footer: error.body.exception, icon: 'error'})
            })

            this.loading = false
        }
    },
}
</script>

<style scoped>

</style>
